<template>
  <div>
    <!-- <div class="draw-up"> -->
    <!-- <div @click="hide" class="bg"></div> -->
    <!-- <div class="draw-up-content"> -->
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect"/>
    <!-- </div> -->
  </div>
</template>

<script>
import { ActionSheet } from 'vant';
export default {
  name: "DrawUp",
  data() {
    return {
      show: false,
      actions: [
        {
          name: "号码错误"
        },
        {
          name: "内容与事实严重不符"
        },
        {
          name: "信息过期，对方已成交"
        },
        {
          name: "不良信息"
        },
        {
          name: "其他"
        }
      ]
    }
  },
  methods: {
    hide() {
      this.$emit("close");
    },
    onSelect(item) {
      // 点击选项时默认不会关闭菜单，可以手动关闭
      this.show = false;
      this.$toast(item.name);
    }
  },
  components:{
    ActionSheet
  }
};
</script>

<style scoped>
.draw-up {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: transparent;
}
.draw-up-content {
  z-index: 1001;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background: transparent;
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(138, 138, 138, 0.377);
  z-index: 1000;
}
</style>
